<template>
  <div>
    <!-- <general-top-bar :title="$t('gestiune.stocks')"></general-top-bar> -->
    <div id="outer-container">
        <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
            <div class="card-content">
                <div class="clearfix row pad-lf-10 pad-rg-10">
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isInitialStock }"
                      @click="openInitialStock"
                    >{{$t('gestiune.initialStock')}}</a>
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isInventar }"
                      @click="openInventar"
                    >{{$t('gestiune.inventar')}}</a>
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isBonConsum }"
                      @click="openBonConsum"
                    >{{$t('gestiune.stoc.action.bonConsum')}}</a>
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isBonProduct }"
                      @click="openBonProduct"
                    >{{$t('gestiune.isBonProductie')}}</a>
                    <!-- <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isLot }"
                      @click="openLot"
                    >{{$t('gestiune.lot')}}</a> -->
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isBonTransfer }"
                      @click="openBonTrasnfer"
                    >{{$t('gestiune.notaTransfer')}}</a>
                    <a
                      class="btn btn-fill btn-primary"
                      :class="{ active: isCasare }"
                      @click="openCasare"
                    >{{$t('gestiune.casare')}}</a>
                </div>
            </div>
        </div>
    </div>
    <div v-if="isInitialStock">
      <ManagementInitialStock :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
    <div v-if="isInventar">
      <ManagementInventory :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
    <div v-if="isBonProduct">
      <ManagementBonProduct :grouped-locations="groupedLocations" :gestiune-options="gestiuneOptions" />
    </div>
    <div v-if="isLot">
      <ManagementLot :grouped-locations="groupedLocations" :gestiune-options="gestiuneOptions" />
    </div>
    <div v-if="isBonConsum">
      <ManagementStocks :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions" />
    </div>
    <div v-if="isBonTransfer">
      <ManagementTransfer :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
    <div v-if="isCasare">
      <ManagementWasted :groupedLocations="groupedLocations" :gestiuneOptions="gestiuneOptions"/>
    </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import ManagementStocks from 'src/components/Dashboard/Views/Management/Stocks/ManagementStocks.vue'
  import ManagementTransfer from 'src/components/Dashboard/Views/Management/Transfer/ManagementTransfer.vue'
  import ManagementInventory from 'src/components/Dashboard/Views/Management/Inventory/ManagementInventory.vue'
  import ManagementInitialStock from 'src/components/Dashboard/Views/Management/InitialStock/ManagementInitialStock.vue'
  import ManagementWasted from 'src/components/Dashboard/Views/Management/Wasted/ManagementWasted.vue'
  import ManagementBonProduct from 'src/components/Dashboard/Views/Management/Nomenclator/ManagementBonProduct.vue'
  import ManagementLot from 'src/components/Dashboard/Views/Management/ManagementLot.vue'

  export default {
    components: {
      // GeneralTopBar,
      ManagementStocks,
      ManagementTransfer,
      ManagementInventory,
      ManagementInitialStock,
      ManagementWasted,
      ManagementBonProduct,
      ManagementLot
    },
    data () {
      return {
        isBonConsum: false,
        isBonTransfer: false,
        isInventar: false,
        isCasare: false,
        isInitialStock: true,
        isBonProduct: false,
        isLot: false
      }
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      gestiuneOptions: {
        type: Array,
        required: true
      }
    },
    created () {
    },
    methods: {
      openBonConsum () {
        this.isBonConsum = true
        this.isBonTransfer = false
        this.isInventar = false
        this.isInitialStock = false
        this.isCasare = false
        this.isBonProduct = false
        this.isLot = false
      },
      openBonTrasnfer () {
        this.isBonConsum = false
        this.isBonTransfer = true
        this.isInventar = false
        this.isInitialStock = false
        this.isCasare = false
        this.isBonProduct = false
        this.isLot = false
      },
      openInventar () {
        this.isBonConsum = false
        this.isBonTransfer = false
        this.isInventar = true
        this.isInitialStock = false
        this.isCasare = false
        this.isBonProduct = false
        this.isLot = false
      },
      openInitialStock () {
        this.isBonConsum = false
        this.isBonTransfer = false
        this.isInventar = false
        this.isInitialStock = true
        this.isCasare = false
        this.isBonProduct = false
        this.isLot = false
      },
      openCasare () {
        this.isBonConsum = false
        this.isBonTransfer = false
        this.isInventar = false
        this.isInitialStock = false
        this.isCasare = true
        this.isBonProduct = false
        this.isLot = false
      },
      openBonProduct () {
        this.isBonProduct = true
        this.isLot = false
        this.isBonConsum = false
        this.isBonTransfer = false
        this.isInventar = false
        this.isInitialStock = false
        this.isCasare = false
      },
      openLot () {
        this.isBonProduct = false
        this.isLot = true
        this.isBonConsum = false
        this.isBonTransfer = false
        this.isInventar = false
        this.isInitialStock = false
        this.isCasare = false
      }
    }
  }
</script>

<style scoped>
.form-check {
display: flex;
gap: 10px;
align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-buttons {
display: flex;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
display: flex; /* Folosește flexbox pentru alinierea orizontală */
justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementStocksTabs.vue